export default __webpack_public_path__ + "static/media/the-star-pressed@2x.0b57a033.png";